module.exports = __webpack_public_path__ + "static/mp4mp3-7dbc3944015a8c8b250f0767fdecdc12.png";